import React from 'react'
import CountdownComponent, { zeroPad, CountdownProps } from 'react-countdown'
import styled from 'styled-components'
import tw from 'tailwind.macro'

const StNumber = styled.div`
  width: 1.5em;
  letter-spacing: -3px;
  text-align: center;
  span {
    ${tw`text-xs block font-normal`}
    letter-spacing: 0;
  }
`
const StPoint = styled.div``

const Renderer = ({ days, hours, minutes, seconds, completed, children }) => {
  if (completed) {
    return <div key="countoff">{children}</div>
  } else {
    return (
      <div key="counton">
        <p className="text-sm p-2 text-center">
          Prontamente revelaremos una encuesta
        </p>

        <div className="font-bold leading-none text-5xl flex grid-cols-7 justify-center">
          <StNumber>
            {zeroPad(days)}
            <span>Días</span>
          </StNumber>
          <StPoint>:</StPoint>
          <StNumber>
            {zeroPad(hours)}
            <span>Horas</span>
          </StNumber>
          <StPoint>:</StPoint>
          <StNumber>
            {zeroPad(minutes)}
            <span>Minutos</span>
          </StNumber>
          <StPoint>:</StPoint>
          <StNumber>
            {zeroPad(seconds)}
            <span>Segundos</span>
          </StNumber>
        </div>
      </div>
    )
  }
}

const Countdown = ({ datetime, children }) => {
  return (
    <div>
      <CountdownComponent
        date={datetime}
        renderer={props => <Renderer {...props}>{children}</Renderer>}
        zeroPadTime={3}
        zeroPadDays={3}></CountdownComponent>
    </div>
  )
}

export default Countdown
